import { NotificationSetting } from '@models/account/notification-setting.model';
import { Utils } from '@utils/utils';

import { ApiAdapter } from './adapter';

export class NotificationsSettingAdapter extends ApiAdapter<NotificationSetting> {
  get(json): NotificationSetting {
    return new NotificationSetting({
      type: json['event_type'],
      activated: Utils.isNullOrUndefined(json['activated']) ? true : json['activated'],
      priority: json['priority'] || '',
    });
  }
}
